import axios from 'axios';

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
}

export async function listThreads(issueId) {
  const res = await axios.get(`/issues/${issueId}/request_threads.json`);
  return res.data.request_threads;
}

export async function createThread(issueId, { body, files = [] }) {
  const formData = new FormData();
  formData.append('request_thread[body]', body);
  Array.from(files).forEach((file) => {
    formData.append('request_thread[files][]', file);
  });

  const res = await axios.post(`/issues/${issueId}/request_threads.json`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.request_thread;
}

export async function postMessage(issueId, threadId, { body, files = [] }) {
  const formData = new FormData();
  formData.append('request_message[body]', body);
  Array.from(files).forEach((file) => {
    formData.append('request_message[files][]', file);
  });

  const res = await axios.post(
    `/issues/${issueId}/request_threads/${threadId}/request_messages.json`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data;
}
